const German = {
  "Yesterday with": "...........",
  'and': '123',
  'concert in LA. Was  totally fantastic! People were really excited about  this one!': '.....................................................',
  '#MotivationMonday': '@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@',
  '#Morning': '###########################################################################',
  "Reference site about Lorem Ipsum, giving information on its origins, as well as  a random Lipsum generator.Reference site about Lorem  Ipsum, giving information on its origins, as well as  a random Lipsum generator.Reference site about Lorem  Ipsum, giving information on its origins, as well as  a random Lipsum generator.": "11111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111",

  "English(en)": "Arabic (ar)",
  "Announcements": "الإنجليزية",
  "Featured Posts": "الإعلانات",
  "Action Required": "المشاركات مميزة",
  "more liked this": "الإجراء مطلوب",
  "Comments": "أكثر أحب هذا",
  "Awards": "تعليقات",
  "Upcoming Birthdays": "الجوائز",
  "Upcoming Work-Anniversaries": "أعياد الميلاد القادمة",
  "Popular Posts": "الذكرى السنوية للعمل القادمة",
  "Upcoming Wedding Anniversaries": "منشورات شائعة",
  "Reference site about lorem ipsum, giving information": "ذكرى الزفاف القادمة",
  "Follow Up Suggestions": "موقع مرجعي عن لوريم إيبسوم يعطي معلومات..",
  "Feed": "متابعة الاقتراحات",
  "Post": "يٌطعم",
  "My Feeds": "بريد",
  "Feed Detail": "خلاصاتي",
  "Featured": "تفاصيل الأعلاف",
  "Pop. Posts": "متميز",
  "Apply": "البوب. دعامات",
  "Team Leaves": "يتقدم",
  "My Leaves": "أوراق الفريق",
  "Hello": "أوراقي",
  "Leave Ledger": "مرحبًا",
  "Org Leaves": "ترك دفتر الأستاذ",
  "Employees": "أوراق المنظمة",
  "All Teams": "موظفين",
  "My Team": "جميع الفرق",
  "Log Out": "فريقي",
  "Awards": "تسجيل خروج",
  "Quick Actions": "الجوائز",
  "Ticket Management": "إجراءات سريعة",
  "Ticket Detail": "إدارة التذاكر",
  "My Tickets": "تفاصيل التذكرة",
  "Add Ticket": "تذاكري",
  "Ticket Detail": "أضف تذكرة",
  "Leave": "تفاصيل التذكرة",
  "Apply": "يترك",
  "My Leaves": "يتقدم",
  "Team Leaves": "أوراقي",
  "Org Leaves": "أوراق الفريق",
  "Leave Ledger": "أوراق المنظمة",
  "My Leave Completed Leave": "ترك دفتر الأستاذ",
  "Gallery": "إجازتي اكتملت الإجازة",
  "Single Gallery": "صالة عرض",
  "Add Media": "معرض واحد",
  "Hr Assessment": "أضف الوسائط",
  "My Assessment": "تقييم الموارد البشرية",
  "EmployeeAssessment": "تقييمي",
  "Hr Assessment": "تقييم الموظف",
  "Recruitment": "تقييم الموارد البشرية",
  "Recruitment Dashboard": "توظيف",
  "Recruitment Details": "لوحة التوظيف",
  "Create Position": "تفاصيل التوظيف",
  "Applicant Details": "إنشاء منصب",
  "Add Applicant": "تفاصيل مقدم الطلب",
  "Applicant Search": "إضافة مقدم الطلب",
  "Work From Home": "بحث مقدم الطلب",
  "Work From Home Dashboard": "العمل من المنزل",
  "My Work From Home": "العمل من لوحة القيادة الرئيسية",
  "Team Work From Home": "عملي من المنزل",
  "Completed": "العمل الجماعي من المنزل",
  "Pending": "مكتمل",
  "More": "قيد الانتظار",
  "Communication Panel": "أكثر",
  "Create Reminders": "لوحة الاتصالات",
  "Reminders": "إنشاء تذكيرات",
  "First time dashboard": "تذكيرات",
  "Audit Trails": "لوحة القيادة لأول مرة",
  "Create Owner Page": "مسارات التدقيق",
  "Account Owner Page": "إنشاء صفحة المالك",
  "Change Password": "صفحة صاحب الحساب",
  "OTP Verification": "تغيير كلمة المرور",
  "Policy": "التحقق من OTP",
  "AddPolicy": "سياسة",
  "Policies": "AddPolicy",
  "Policydetail": "سياسات",
  "All Teams": "تفاصيل السياسة",
  "My Teams": "جميع الفرق",
  "New": "فرقي",
  "Self Learning": "جديد",
  "Instructor Training": "التعلم الذاتي",
  "Task Management": "تدريب المدربين",
  "Task Detail": "ادارة المهام",
  "Search": "تفاصيل المهمة",
  "Search Result": "يبحث",
  "What would you like to search": "نتيجة البحث",
  "Search Employee & their post": "ماذا تريد أن تبحث",
  "Profile": "البحث عن الموظف ومنشوراته",
  "Change password": "حساب تعريفي",
  "Send Us Feedback": "تغيير كلمة المرور",
  "2022 © OrgGenie - Your Organization Portal. Powered By": "أرسل لنا ردود الفعل",
  "BizBrolly": "2022 © OrgGenie - بوابة مؤسستك. مشغل بواسطة",
  "Version 16.6": "بيزبرولي",
  "Log Out": "الإصدار 16.6",
  "Add App": "تسجيل خروج",
  "App Title": "أضف التطبيق",
  "Links": "عنوان التطبيق",
  "Existing App": "روابط",
  "Apps": "التطبيق الموجود",
  "Decline": "تطبيقات",
  "Save": "انخفاض",


};

export default German;
